<template>
    <v-card>
        <v-layout wrap>
            <v-flex xs12 class="print-only">
                <v-layout wrap>
                    <v-flex xs12>
                        <h2 class="text-xs-center">{{ printTitle }}</h2>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 class="print-only">
                <v-layout wrap class="details-check">
                    <v-flex xs2 offset-xs2>
                        Name
                    </v-flex>
                    <v-flex xs6 class="underlined-box">

                    </v-flex>
                    <v-flex xs2 offset-xs2>
                        Date
                    </v-flex>
                    <v-flex xs6 class="underlined-box">

                    </v-flex>
                    <v-flex xs2 offset-xs2>
                        Signature
                    </v-flex>
                    <v-flex xs6 class="underlined-box">

                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-layout class="notPrinted">
                    <v-flex xs12>
                        <h1 class="text-xs-center">Check Banking Details</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="notPrinted">
                    <v-flex xs12 sm12 md6 offset-md3>
                        <v-btn
                            color="navigation"
                            block
                            @click="backToBankingDetails()"
                        >
                            Back to Banking Details
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm8 md4 offset-md3 @click="pickABAFile">
                        <v-text-field
                            prepend-icon="cloud_upload"
                            disabled
                            label="Choose an ABA File"
                            v-model="abaFileName"
                        ></v-text-field>
                        <input
                            type="file"
                            style="display: none"
                            ref="image"
                            accept=".aba"
                            @change="onABAFilePicked"
                        >
                    </v-flex>
                    <v-flex xs12 sm4 md2>
                        <v-btn block color="accent" :disabled="checking" @click="pickABAFile">Choose File</v-btn>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3>
                        <v-btn block color="success" :disabled="checking" @click="checkBankingDetails">Check Banking Details</v-btn>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3>
                        <v-btn
                            color="accent"
                            block
                            :disabled="totalItems == 0"
                            @click="triggerPrint()">
                            Print
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3 v-if="abaProcessError">
                        <error-alert :content="abaProcessError" display="true"></error-alert>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3 v-if="totalItems > 0">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Banking Details"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout v-if="sortedPaginatedComparisonData.length > 0">
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="sortedPaginatedComparisonData"
                            :loading="checking"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                            :total-items="totalItems">
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :class="rowClass(props.item)" v-if="!props.item.IsTotal">
                                    <td class="printOnlyTableCell">
                                        <v-icon :color="rowIconColor(props.item)">{{ rowIcon(props.item) }}</v-icon>
                                    </td>
                                    <td>{{props.item.Name}}</td>
                                    <td>{{formatBSB(props.item.existing.BSB)}}</td>
                                    <td>{{props.item.existing.BankAccountNumber}}</td>
                                    <td>{{formatBSB(props.item.BSB)}}</td>
                                    <td>{{props.item.BankAccountNumber}}</td>
                                    <td>${{props.item.Amount}}</td>
                                    <td class="notPrinted">{{props.item.Details}}</td>

                                    <td class="notPrinted">  
                                        <v-btn
                                            v-if="props.item.CompareResultType != compareResultType.Match"
                                            color="warning"
                                            block
                                            @click="editBankingDetails(props.item)"
                                            >
                                            {{props.item.CompareResultType == compareResultType.PresentInABAFileOnly ? "Add" : "Edit"}}
                                        </v-btn> 
                                    </td>
                                </tr>
                                <tr class="printOnlyTableRow" v-if="!props.item.IsTotal && props.item.Details != ''">
                                    <td colspan="7">
                                        <span>Details: {{props.item.Details}}</span>
                                    </td>
                                </tr>
                                <td :colspan="headers.length" class="noBackgroundPrint" v-if="props.item.IsTotal">
                                    <table style="width: 100%">
                                        <thead>
                                            <tr>
                                                <th>Net Total</th>
                                                <th>Credit Total</th>
                                                <th>Debit Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td align="center">${{ props.item.NetTotal }}</td>
                                                <td align="center">${{ props.item.CreditTotal }}</td>
                                                <td align="center">${{ props.item.DebitTotal }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                        <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark :disabled="saving" @click="cancelEditBankingDetails">
                                        <v-icon large>close</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title v-if="editedBankingDetails && editedBankingDetails.ID">Edit Banking Details</v-toolbar-title>
                                    <v-toolbar-title v-else>Add New Banking Details</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-form ref="editForm" v-model="editBankingDetailsValid">
                                    <v-layout class="dialog-content">
                                        <v-flex xs12 md6 offset-md3>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        clearable
                                                        counter="100"
                                                        maxlength="100"
                                                        v-model="editedBankingDetails.Name"
                                                        :rules="[rules.required]"
                                                        label="Company Name">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        clearable
                                                        counter="15"
                                                        maxlength="15"
                                                        :rules="[rules.numericOrEmpty]"
                                                        v-model="editedBankingDetails.ABN" 
                                                        label="ABN / ACN">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        clearable 
                                                        :rules="[rules.bsb]"
                                                        :mask="bsbMask(editedBankingDetails.BSB)"
                                                        v-model="editedBankingDetails.BSB" 
                                                        label="BSB">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        clearable
                                                        counter="15"
                                                        maxlength="15"
                                                        :rules="[rules.numericOrEmpty]"
                                                        v-model="editedBankingDetails.BankAccountNumber" 
                                                        label="Bank Account Number">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-checkbox label="Active" v-model="editedBankingDetails.Active"></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap class="dialog-action-buttons">
                                                <v-flex xs12 sm6>
                                                    <v-btn block color="error" :disabled="saving" @click="cancelEditBankingDetails">Cancel</v-btn>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-btn block color="success" :disabled="!editBankingDetailsValid" :loading="saving" @click="saveEditedBankingDetails">Save</v-btn>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <error-alert :content="saveError" :display="saveError"></error-alert>
                                                </v-flex>
                                            </v-layout>                            
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-card>
                        </v-dialog>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import constant from "../../services/constant";

export default {
    components: {
        ErrorAlert,
    },
    data() {
        return {
            abaFileName: "",
            abaFileData: "",
            abaNameOfUse: null,
            abaProcessedData: null,
            abaProcessError: "",
            processing: false,
            rowsPerPage: [20, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            pagination: {
                rowsPerPage: -1, // default
                sortBy: "Index"
            },
            search: "",
            headers: [
                {
                    text: "",
                    value: "Edit",
                    class: "print-only",
                    sortable: false
                },
                {
                    text: "Company Name",
                    value: "Name",
                    sortable: false
                },
                {
                    text: "BSB",
                    value: "ExistingBSB",
                    width: 100,
                    sortable: false
                },
                {
                    text: "Bank\nAccount",
                    value: "ExistingBankAccountNumber",
                    sortable: false
                },
                {
                    text: "Imported\nBSB",
                    value: "BSB",
                    class: "printOnlyKeepSpaces",
                    sortable: false
                },
                {
                    text: "Imported\nBank\nAccount",
                    value: "BankAccountNumber",
                    class: "printOnlyKeepSpaces",
                    sortable: false
                },
                {
                    text: "Transaction\nAmount",
                    value: "Amount",
                    class: "printOnlyKeepSpaces",
                    sortable: false
                },
                {
                    text: "Details",
                    value: "Details",
                    class: "notPrinted",
                    sortable: false
                },
                {
                    text: "Edit/Add",
                    value: "Edit",
                    class: "notPrinted",
                    sortable: false
                }
            ],
            compareResultType : {
                Match: 1,
                DataNotMatch: 2,
                PresentInABAFileOnly: 3,
                PresentInOrderingSystemOnly: 4
            },
            editedBankingDetails: {},
            showEditDialog: false,
            editBankingDetailsValid: false,
            rules: validationRules.rules

        };
    },
    computed: {
        loading() {
            return this.$store.state.bankingDetailsStore.loading;
        },
        loadError() {
            return this.$store.state.bankingDetailsStore.loadError;
        },
        bankingDetails() {
            return this.$store.state.bankingDetailsStore.bankingDetails.filter(s => s.Active && s.CompanyID == this.companyID );
        },
        saving() {
            return this.$store.state.bankingDetailsStore.saving;
        },
        saveError() {
            return this.$store.state.bankingDetailsStore.saveError;
        },
        checking() {
            return this.loading || this.processing;
        },
        checkError() {
            return this.loadError || this.abaProcessError;
        },
        totalItems(){
            return this.comparisonData.length;
        },
        sortedPaginatedComparisonData(){
            let sortBy = this.pagination.sortBy;
            if(sortBy == null){
                sortBy = "Index";
            }

            let descending = this.pagination.descending;
            if(descending == null){
                descending = false;
            }

            let page = this.pagination.page;
            if(page == null){
                page = 1;
            }

            let rowsPerPage = this.pagination.rowsPerPage;

            return this.comparisonData.filter(x => {
                if(this.search == null){
                    return true;
                }

                for(let i = 0; i < this.headers.length; i++){
                    let value = x[this.headers[i].value];

                    if(this.headers[i].value === "ExistingBSB" || this.headers[i].value === "BSB"){
                        value = this.formatBSB(value);
                    }

                    if(this.headers[i].value === "Amount"){
                        value = "$" + value;
                    }

                    if((value + "").toLowerCase().includes(this.search.toLowerCase())){
                        return true;
                    }
                }

                return false;
            }).sort((a, b) => {
                if(a.IsTotal && !b.IsTotal){
                    return 1;
                }

                if(!a.IsTotal && b.IsTotal){
                    return -1;
                }

                if(a[sortBy] == null && b[sortBy] != null){
                    return 1;
                }

                if(a[sortBy] != null && b[sortBy] == null){
                    return -1;
                }

                if(a[sortBy] == null && b[sortBy] == null){
                    return 0;
                }

                if(a[sortBy] > b[sortBy]){
                    return descending ? -1 : 1;
                }

                if(a[sortBy] < b[sortBy]){
                    return descending ? 1 : -1;
                }

                return 0;
            }).slice(
                (page - 1) * rowsPerPage, 
                page * rowsPerPage
            );
        },
        comparisonData() {
            let data = [];

            if (this.bankingDetails && this.bankingDetails.length > 0 && this.abaProcessedData && this.abaProcessedData.length >= 0) {
                // go through each imported record and add extra properties from our existing records

                for (let i=0; i<this.abaProcessedData.length; i++) {
                    let imported = this.abaProcessedData[i];
                    if(imported.IsTotal){
                        data.push(imported);
                        continue;
                    }
                    
                    imported.CompareResultType = this.compareResultType.Match
                    imported.Details = ""
                    imported.DetailsShort = "Match";
                    // find existing record with same name
                    // trim spaces from start and end, and also reduce any multiple whitespace sequences to a single space
                    let existing = this.bankingDetails.find(b => b.Name.toUpperCase().replace(/\s\s+/g, ' ').trim() === imported.Name.toUpperCase().replace(/\s\s+/g, ' ').trim());
                    imported.existing = existing;
                    imported.ABN = imported.existing ? imported.existing.ABN : null
                    imported.Active = true
                    imported.ID = imported.existing ? imported.existing.ID : null
                    if (existing) {
                        existing.FoundInFile = true;
                        imported.IsEdit = true;
                        imported.ExistingBSB = existing.BSB;
                        imported.ExistingBankAccountNumber = existing.BankAccountNumber;
                        imported.NoExisting = false;

                        if (imported.BSB !== imported.existing.BSB || imported.BankAccountNumber !== imported.existing.BankAccountNumber) {
                            imported.Details = "Data does not match";
                            imported.DetailsShort = "Not match";

                            imported.CompareResultType = this.compareResultType.DataNotMatch
                        }
                        else {

                        }
                    }
                    else {
                        imported.NoExisting = true;
                        imported.existing = {};
                        imported.Details = "Data in ABA file not present in Produce Ordering System";
                        imported.DetailsShort = "Not match";
                        imported.CompareResultType = this.compareResultType.PresentInABAFileOnly

                    }

                    data.push(imported);
                }

                // Loop through our records and flag them if not found in the ABA file
                for(let i=0; i< this.bankingDetails.length; i++) {
                    let existing = this.bankingDetails[i];
                    //FC1-187 only display results in the .aba file
                    // if(!existing.FoundInFile) {
                    //     data.push({
                    //         Name: existing.Name.trim(),
                    //         existing: existing,
                    //         Details: "Data in Produce Ordering System not present in ABA file",
                    //         NoFileEntry: true
                    //     })
                    // }
                }
            }

            return data;
        },
        companyID() {
            return this.$route.meta.companyID;
        },
        printTitle(){
            if(this.abaNameOfUse != null){
                return this.abaNameOfUse;
            }

            return this.abaFileName;
        }
    },
    methods: {
        rowClass(item) {
            if (item.NoExisting) {
                return "no-existing";
            }
            else if(item.NoFileEntry) {
                return "no-file-entry";
            }
            else if (item.Details) {
                return "not-matched";
            }
            else {
                return "matched";
            }
        },
        rowIcon(item){
            if (item.Details != '') {
                return 'close';
            }

            return 'done';
        },
        rowIconColor(item){
            if (item.Details != '') {
                return 'error';
            }

            return 'success';
        },
        formatBSB(value) {
            return formatters.formatBSB(value);
        },
        checkBankingDetails() {
            this.processing = true;
            this.abaProcessError = "";
            this.abaProcessedData = null;

            this.processABAFile();

            if (!this.abaProcessError) {
                this.loadBankingDetails();
            }
        },
        loadBankingDetails() {
            this.$store.dispatch("bankingDetailsStore/loadBankingDetails");
        },
        backToBankingDetails() {
            if(this.companyID == constant.CompanyID.JCG.ID) {
                this.$router.push({ name: "bankingdetailsjcg" });
            }
            else if(this.companyID == constant.CompanyID.SBD.ID) {
                this.$router.push({ name: "bankingdetailssbd" });
            }
            else if(this.companyID == constant.CompanyID.CRG.ID) {
                this.$router.push({ name: "bankingdetailscrg" });
            }
            else if(this.companyID == constant.CompanyID.CG.ID) {
                this.$router.push({ name: "bankingdetailscg" });
            }
        },
        pickABAFile() {
            this.$refs.image.click();
        },
        onABAFilePicked(e) {
            // file upload adapted from https://stackoverflow.com/questions/44989162/file-upload-in-vuetify
            const files = e.target.files;
            
			if(files[0] !== undefined) {
                this.abaFileName = files[0].name;
                this.logoFileName = this.abaFileName;
                
                if(this.abaFileName.lastIndexOf('.') <= 0) {
					return;
				}

				const fr = new FileReader();
				fr.addEventListener("load", () => {
                    this.abaFileName = files[0].name;
                    this.logoFileName = this.abaFileName;

                    this.abaFileData = fr.result; // this is an image file that can be sent to server
                });
                fr.readAsText(files[0]);
            }
            else {
                this.abaFileName = "";
                this.logoFileName = this.abaFileName;
                this.abaFileData = "";
            }
        },
        processABAFile() {
            /**
             * Processes the ABA file data into a JSON object, for us to compare to internal data
             */
            try {
                this.processing = true;

                this.abaProcessedData = null;

                let data = [];

                let lines = this.abaFileData.split("\n");
                for (let i=0; i<lines.length; i++) {
                    let line = lines[i];

                    let lineData = this.processABAFileLine(line);
                    if (lineData) {
                        lineData.Index = i;
                        data.push(lineData);
                    }
                }

                this.abaProcessedData = data;
            }
            catch (err) {
                this.abaProcessError = err;
            }
            finally {
                this.processing = false;
            }
        },
        processABAFileLine(line) {
            /**
             * Returns an object with the data from the given line, or null
             * if the data in this line is not appropriate.
             * 
             * ABA file format: https://www.cemtexaba.com/aba-format/cemtex-aba-file-format-details
             */

            var recordType = line.slice(0, 1);

            if (isNaN(recordType)) {
                // this does not look like it is a properly formatted ABA file - abort!
                throw "The selected file is not a properly formatted ABA file";
            }

            if(recordType === "0"){
                this.abaNameOfUse = line.slice(30, 56);
            }

            if(recordType === "1"){
                var bsb = line.slice(1, 8).replace("-", "");
                var accountNumber = line.slice(8, 17);
                // var indicator = line.slice(17, 18);
                // var transactionCode = line.slice(18, 20);
                var amount = line.slice(20, 30);
                var accountTitle = line.slice(30, 62);
                // var lodgementReference = line.slice(62, 80);
                // var traceRecord = line.slice(80, 87);
                // var otherAccountNumber = line.slice(87, 96);
                // var remitterName = line.slice(96, 112);
                // var withholdingTax = line.slice(112, 120);

                let dummyBankingDetails = {
                    IsTotal: false,
                    BSB: bsb.trim(),
                    BankAccountNumber: accountNumber.trim(),
                    Name: accountTitle.trim(),
                    Amount: amount/100
                };

                return dummyBankingDetails;
            }

            if(recordType === "7"){
                var netTotal = line.slice(20, 30);
                var creditTotal = line.slice(30, 40);
                var debitTotal = line.slice(40, 50);

                let dummyBankingDetails = {
                    IsTotal: true,
                    NetTotal: netTotal/100,
                    CreditTotal: creditTotal/100,
                    DebitTotal: debitTotal/100
                };

                return dummyBankingDetails;
            }

            // do not process this line
            return null;
        },
        triggerPrint(){
            window.print();
        },
        editBankingDetails(item) {
            this.$store.dispatch("bankingDetailsStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();
            
            this.editedBankingDetails = Object.assign({}, item);

            //If this is edit mode, show the existing data in the system
            if(this.editedBankingDetails.IsEdit == true) {
                this.editedBankingDetails.BankAccountNumber = this.editedBankingDetails.ExistingBankAccountNumber;
                this.editedBankingDetails.BSB = this.editedBankingDetails.ExistingBSB;
            }
            this.showEditDialog = true;
        },
        cancelEditBankingDetails() {
            this.showEditDialog = false;
            this.editedBankingDetails = {};
        },
        saveEditedBankingDetails() {
            var that = this;

            //Create a new object to match the table schema 
            var bankDetails = {
                ID: this.editedBankingDetails.ID,
                Name: this.editedBankingDetails.Name,
                ABN: this.editedBankingDetails.ABN,
                BSB: this.editedBankingDetails.BSB,
                Active: this.editedBankingDetails.Active,
                BankAccountNumber: this.editedBankingDetails.BankAccountNumber,
                CompanyID: this.companyID   
            }
            this.$store.dispatch("bankingDetailsStore/saveBankingDetails", {
                bankingDetails: bankDetails,
                finally: function() {
                    if (that.$store.state.bankingDetailsStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditBankingDetails();
                        this.checkBankingDetails();
                    }
                }
            });
        },
        bsbMask(value) {
            return validationRules.bsbMask(value);
        },
        phoneMask(value) {
            return validationRules.phoneMask(value);
        },
        formatPhoneNumber(value) {
            return formatters.formatPhoneNumber(value);
        },
        formatBSB(value) {
            return formatters.formatBSB(value);
        }
    },
    created() {
    }
};
</script>

<style>
    .grid-action-buttons .flex {
        /* just prevent buttons that are side by side from touching each other */
        padding-right: 5px;
        padding-left: 5px;
    }

    .no-existing {
        background-color: #FFF59D;
    }

    .no-file-entry {
        background-color: rgb(247, 144, 60);
    }

    .not-matched {
        background-color: #EF9A9A;
    }

    .matched {
        background-color: #C5E1A5;
    }

    @media print {
        .no-existing, .no-existing td {
            background-color: transparent !important;
        }

        .no-file-entry, .no-file-entry td {
            background-color: transparent !important;
        }

        .not-matched, .not-matched td {
            background-color: transparent !important;
        }

        .matched, .matched td {
            background-color: transparent !important;
        }

        .printOnlyTableRow, .printOnlyTableRow td {
            background-color: transparent !important;
        }

        .printOnlyKeepSpaces {
            white-space: pre-wrap !important;
        }
    }

    .printShowCell {
        display: none;
    }

    .printHideCell {
        display: table-cell;
    }
</style>
